import React, { useState } from "react";
import { Flex, Checkbox, Input } from "@theorgchartdev/storybook";
import { GetWSMgr } from "@/Utils/StateLib";
import { Globals } from "@coreapp/CoreApp/Globals";
import { QGetUserListRFC } from "@coreapp/CoreApp/QGetUserListRFC";
import { QAlert } from "@coreapp/CoreApp/QAlert";
import { enumFeaturesList, enumMFAState } from "@coreapp/constants";
import { appstr } from "@coreapp/utils/appstr";
import { getFeatureAccess } from "@/Utils/Misc";

export const GeneralSection = ({ accountConfig, handleUpdate }) => {
  if (!accountConfig) return;
  const [mfaSummary, setmfaSummary] = useState(null);

  const securityObj = accountConfig.security;
  const mfaObject = securityObj?.mfa || {};
  const signOutObj = securityObj?.signout || {};
  const adminImpersonation = securityObj?.adminimpersonation ?? false;
  let wsMgr = GetWSMgr();
  let currentEdition = accountConfig?.edition;
  let hasAdvSec =
    !getFeatureAccess(enumFeaturesList.hasAdvSec) && !accountConfig?.security.mfa.mfaRequired;

  const DoUserRFC = () => {
    const callbackObj = {
      InactiveMFAWarning: result => {
        setmfaSummary(result);
        enableMfaAlert(result);
      },
      GetUserListResult: result => {
        GetUserListResult(result);
      }
    };
    let wsMgr = GetWSMgr();
    var ulRFC = new QGetUserListRFC();
    ulRFC.InitGetUserListRFC(callbackObj);
    var orgInfo = wsMgr.GetOrgInfo();
    var accountName = orgInfo.fAccountName;
    var user = wsMgr.GetUserName();
    ulRFC.SetParams(accountName, user, null, true);
    Globals._rfcMgr.QueueRFC(ulRFC);
  };

  const GetUserListResult = success => {
    if (!success) {
      var alert = new QAlert();
      alert.InitAlert(appstr("Alert"), appstr("userlisterr"), null, Globals._wsMgr, true);
    }
  };
  const HandleCheckboxToggle = key => {
    let updatedAccountConfig = { ...accountConfig };
    let updatedSecurityObj = { ...updatedAccountConfig.security };
    let mfaEnable = updatedSecurityObj?.mfa?.mfaRequired;

    let wsMgr = GetWSMgr();
    let curUser = wsMgr.GetUserInfo();
    let curUserBackendState = curUser.GetMFA("backendMFAState");

    switch (key) {
      case "mfaRequired":
        if (accountConfig?.security.mfa && accountConfig?.security.mfa.mfaRequired) {
          disableMfaAlert();
        } else if (curUserBackendState === enumMFAState.enabledAuth) {
          DoUserRFC();
        } else {
          mfaAlert();
        }
        break;
      case "customSignOut":
        let updatedSignOutObj = { ...signOutObj };
        if (!(key in updatedSignOutObj)) updatedSignOutObj.customSignOut = false;
        updatedSignOutObj.customSignOut = !updatedSignOutObj.customSignOut;
        updatedSecurityObj.signout = updatedSignOutObj;
        break;
      case "directsigninenabled":
        const curValue = (updatedSecurityObj.directsigninenabled =
          !updatedSecurityObj.directsigninenabled);
        const mfaEnabled = updatedSecurityObj?.mfa?.mfaRequired;
        if (mfaEnabled && !curValue) updatedSecurityObj.mfa.mfaRequired = false;
        updatedSecurityObj.directsigninenabled = curValue;
        break;
      case "adminimpersonation":
        updatedSecurityObj.adminimpersonation = !updatedSecurityObj.adminimpersonation;
        break;
      case "assignMFA":
        const mfa = updatedSecurityObj?.mfa?.mfaRequired;
        if (mfa) updatedSecurityObj.mfa.mfaRequired = false;
        else updatedSecurityObj.mfa.mfaRequired = true;
        break;
      default:
        break;
    }

    updatedAccountConfig.security = updatedSecurityObj;
    handleUpdate(updatedAccountConfig, "security");
  };

  const HandleCustomSOInput = value => {
    let updatedAccountConfig = { ...accountConfig };
    let updatedSignOutObj = { ...signOutObj };
    updatedSignOutObj.signOutURL = value;
    updatedAccountConfig.security = { ...accountConfig.security, signout: updatedSignOutObj };
    handleUpdate(updatedAccountConfig, "security");
  };

  const mfaAlert = (skipCheck = false) => {
    const wsMgr = GetWSMgr();
    if (!skipCheck) {
      wsMgr.CreateReactAlert(
        appstr("Required & Not Configured"),
        appstr("mfaAdminPreReq"),
        () => openMfaModal(),
        () => {},
        appstr("Configure"),
        appstr("Cancel")
      );
      return;
    }
  };

  const enableMfaAlert = (result, skipCheck = false) => {
    let numInactiveMFA = result?.mfaInactive;
    let msg = numInactiveMFA + " " + appstr("mfaInactivePost");
    msg = numInactiveMFA ? msg : appstr("reqMFAWarning");
    const wsMgr = GetWSMgr();
    if (!skipCheck) {
      wsMgr.CreateReactAlert(
        appstr("Enable MFA requirement"),
        numInactiveMFA ? msg : appstr("reqMFAWarning"),
        () => HandleCheckboxToggle("assignMFA"),
        () => {},
        appstr("Enable anyways"),
        appstr("Cancel")
      );
      return;
    }
  };

  const disableMfaAlert = (skipCheck = false) => {
    const wsMgr = GetWSMgr();
    if (!skipCheck) {
      wsMgr.CreateReactAlert(
        appstr("Disable MFA requirement"),
        appstr("mfaNotRequired"),
        () => HandleCheckboxToggle("assignMFA"),
        () => HandleCheckboxToggle("assignMFA"),
        appstr("Turn off MFA"),
        appstr("Cancel")
      );
      return;
    }
  };

  const openMfaModal = () => {
    wsMgr.BroadcastTopic("MFAModal", true);
  };

  return (
    <Flex direction={"column"} gap={"8px"}>
      <Checkbox
        key={"auth-chkbx-mfa"}
        id={"auth-chkbx-mfa"}
        data-testid="account-settings-authorization-mfa-required-checkbox"
        size="medium"
        label={appstr("MFA Required")}
        checked={mfaObject?.mfaRequired}
        onToggle={() => HandleCheckboxToggle("mfaRequired")}
        disabled={!getFeatureAccess(enumFeaturesList.MFA)}
      />
      <Checkbox
        key={"auth-enable-admin"}
        id={"auth-enable-admin"}
        data-testid="account-settings-authorization-admin-impersonation-checkbox"
        size="medium"
        label={appstr("Enable Administrator User Impersonation")}
        checked={adminImpersonation}
        onToggle={() => HandleCheckboxToggle("adminimpersonation")}
        disabled={!getFeatureAccess(enumFeaturesList.adminUserImpersonation)}
      />
      <Checkbox
        key={"auth-enable-direct"}
        id={"auth-enable-direct"}
        data-testid="account-settings-authorization-direct-signin-checkbox"
        size="medium"
        label={appstr("Direct Sign-In")}
        checked={securityObj.directsigninenabled}
        onToggle={() => HandleCheckboxToggle("directsigninenabled")}
      />
      <Flex direction={"row"} alignItems={"center"} gap={"8px"}>
        <Checkbox
          key={"auth-signout-enable"}
          id={"auth-signout-enable"}
          data-testid="account-settings-authorization-custom-signout-checkbox"
          size="medium"
          label={`${appstr("Custom Sign-Out URL")}:`}
          checked={signOutObj?.customSignOut}
          onToggle={() => HandleCheckboxToggle("customSignOut")}
          disabled={!getFeatureAccess(enumFeaturesList.signoutRedirectURL)}
        />
        <Input
          key={"auth-signout-input"}
          dataTestId="account-settings-authorization-custom-signout-input"
          value={signOutObj?.signOutURL || ""}
          type={"text"}
          size={"small"}
          disabled={
            !signOutObj?.customSignOut || !getFeatureAccess(enumFeaturesList.signoutRedirectURL)
          }
          onChange={e => HandleCustomSOInput(e.target.value)}
        />
      </Flex>
    </Flex>
  );
};
